import { Plane, Building2, Stethoscope, HeartHandshake, Clock, Phone, FileText, Car, Utensils, Pill, Microscope, Activity } from "lucide-react";
import type { IncludedItem } from "@/types/schema";

export interface DetailedTreatmentData {
  procedure_details?: string;
  recovery_info?: string;
  included_items?: IncludedItem[];
}

export const treatmentData: Record<string, DetailedTreatmentData> = {
  "all-on-4-implants": {
    procedure_details: "The All-on-4® treatment concept facilitates the complete rehabilitation of the full dental arch (upper or lower jaw) with only four implants. Two straight anterior implants and two tilted posterior implants are placed. This tilting allows for better bone-to-implant contact, often eliminating the need for bone grafting. A temporary set of fixed teeth is often placed on the same day (Teeth-in-a-Day).",
    recovery_info: "Most patients experience minor swelling and discomfort for the first 2-3 days, manageable with standard medication. You can typically return to work within 3-4 days. A soft food diet is required for the first few months while osseointegration (bone healing) occurs. The final permanent bridge is attached after 3-6 months of healing.",
    included_items: [
      {
        icon: Microscope,
        title: "CT Scan & X-Rays",
        description: "3D CBCT scan and digital OPG for precise planning",
        category: "medical",
      },
      {
        icon: Stethoscope,
        title: "4 Dental Implants",
        description: "Premium titanium implants (Nobel Biocare/Straumann)",
        category: "medical",
      },
      {
        icon: Activity,
        title: "Temporary Prosthesis",
        description: "Fixed acrylic bridge placed immediately after surgery",
        category: "medical",
      },
      {
        icon: Stethoscope,
        title: "Surgeon Fees",
        description: "Professional fees for implantologist and prosthodontist",
        category: "medical",
      },
      {
        icon: Plane,
        title: "Airport Transfers",
        description: "Luxury pickup and drop-off at the airport",
        category: "travel",
      },
      {
        icon: Car,
        title: "Local Transport",
        description: "Daily transfers between hotel and dental clinic",
        category: "travel",
      },
      {
        icon: Pill,
        title: "Medications",
        description: "Full course of antibiotics and painkillers",
        category: "medical",
      },
      {
        icon: Phone,
        title: "24/7 Coordinator",
        description: "English-speaking personal case manager",
        category: "support",
      },
      {
        icon: FileText,
        title: "Warranty",
        description: "Lifetime warranty on implants",
        category: "support",
      }
    ]
  }
};
